import { css } from '@emotion/css';

export const p3 = css`
  padding: 0.3rem;
`;
